<!-- Ports Management -->
<div class="d-flex flex-column flex-column-fluid">
  <!-- Ports Listing -->
  <div class="card">
    <!-- Card Header -->
    <div class="card-header border-0 pt-6">
      <div class="card-title">
        <!-- Search -->
        <div class="d-flex align-items-center position-relative my-1">
          <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <input type="text" [(ngModel)]="searchTerm" (keyup.enter)="onSearch()"
            class="form-control form-control-solid w-250px ps-13" placeholder="Search ports..." />
        </div>
      </div>

      <!-- Card Toolbar -->
      <div class="card-toolbar">
        <!-- Save Changes Button -->
        <div class="d-flex justify-content-end align-items-center" data-kt-user-table-toolbar="base">
          <button *ngIf="hasChanges" type="button" class="btn btn-success me-3" (click)="saveChanges()"
            [disabled]="isSaving">
            <span *ngIf="!isSaving" class="indicator-label">
              <i class="ki-duotone ki-check fs-2">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
              Save Changes
            </span>
            <span *ngIf="isSaving" class="indicator-progress">
              Please wait...
              <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          </button>

          <!-- Add Port Button -->
          <button type="button" class="btn btn-primary" (click)="openAddPortModal()">
            <i class="ki-duotone ki-plus fs-2">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
            </i>
            Add Port
          </button>
        </div>
      </div>
    </div>

    <!-- Card Body -->
    <div class="card-body py-4">
      <!-- Ports Table -->
      <div class="table-responsive">
        <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
          <thead>
            <tr class="fw-bold text-muted bg-light">
              <th class="min-w-150px">Port Name</th>
              <th class="min-w-150px">Parent Country</th>
              <th class="min-w-120px">Show as From</th>
              <th class="min-w-100px">Display</th>
              <th class="min-w-100px">Created Date</th>
              <th class="min-w-100px">Actions</th>
            </tr>
          </thead>
          <tbody>
            <!-- Loading State -->
            <tr *ngIf="isLoading">
              <td colspan="6" class="text-center py-5">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>

            <!-- No Data State -->
            <tr *ngIf="!isLoading && ports.length === 0">
              <td colspan="6" class="text-center py-5">
                <div class="text-muted">No ports found</div>
              </td>
            </tr>

            <!-- Port Rows -->
            <tr *ngFor="let port of ports; trackBy: trackByFn" class="odd">
              <td>
                <div class="d-flex flex-column">
                  <span class="text-dark fw-bold text-hover-primary mb-1 fs-6">
                    {{ port.name || '-' }}
                  </span>
                </div>
              </td>
              <td>
                <span class="text-muted fw-semibold text-muted d-block fs-7">
                  {{ port.parent?.name || port.country?.name || '-' }}
                </span>
              </td>
              <td class="text-center">
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" [checked]="port.show_as_from || false"
                    (change)="onCheckboxChange(port, 'show_as_from', $event)" [id]="'show_as_from_' + port._id" />
                </div>
              </td>
              <td class="text-center">
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" [checked]="port.display || false"
                    (change)="onCheckboxChange(port, 'display', $event)" [id]="'display_' + port._id" />
                </div>
              </td>
              <td>
                <span class="text-muted fw-semibold text-muted d-block fs-7">
                  {{ port.created_at | date:'short' }}
                </span>
              </td>


              <td class="">
                <div class="d-flex justify-content-end gap-2">
                  <!-- Edit Button -->
                  <button type="button" class="btn btn-sm btn-icon btn-light-primary" (click)="openEditPortModal(port)"
                    title="Edit Port">
                    <i class="ki-duotone ki-pencil fs-6">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </button>

                  <!-- Delete Button -->
                  <button type="button" class="btn btn-sm btn-icon btn-light-danger" (click)="deletePort(port)"
                    title="Delete Port">
                    <i class="ki-duotone ki-trash fs-6">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                      <span class="path4"></span>
                      <span class="path5"></span>
                    </i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="row" *ngIf="!isLoading && ports.length > 0">
        <div class="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start">
          <div class="dataTables_length">
            <span class="text-muted">
              Showing {{ ((paginationInfo.currentPage - 1) * paginationInfo.perPage) + 1 }} to
              {{ Math.min(paginationInfo.currentPage * paginationInfo.perPage, paginationInfo.total) }} of
              {{ paginationInfo.total }} entries
            </span>
          </div>
        </div>
        <div class="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <!-- Previous Button -->
              <li class="paginate_button page-item previous" [class.disabled]="paginationInfo.currentPage === 1">
                <a href="javascript:;" class="page-link"
                  (click)="paginationInfo.currentPage > 1 && onPageChange(paginationInfo.currentPage - 1)">
                  <i class="previous"></i>
                </a>
              </li>

              <!-- Page Numbers -->
              <li class="paginate_button page-item"
                *ngFor="let page of [].constructor(paginationInfo.lastPage); let i = index"
                [class.active]="(i + 1) === paginationInfo.currentPage">
                <a href="javascript:;" class="page-link" (click)="onPageChange(i + 1)">{{ i + 1 }}</a>
              </li>

              <!-- Next Button -->
              <li class="paginate_button page-item next"
                [class.disabled]="paginationInfo.currentPage === paginationInfo.lastPage">
                <a href="javascript:;" class="page-link"
                  (click)="paginationInfo.currentPage < paginationInfo.lastPage && onPageChange(paginationInfo.currentPage + 1)">
                  <i class="next"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Port Add/Edit Modal -->
<app-add-edit-port (portAdded)="onPortAdded()" (portUpdated)="onPortUpdated()">
</app-add-edit-port>